import { CONSTRUCTOR } from '..';
import * as Fragments from './fragments';

// Opportunity GraphQL Mutations.

// UPDATE update opportunity field GraphQL schema.
export const UPDATE = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'updateOpportunityFieldSettings',
    args: [
      { name: 'content', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'content', value: 'content' },
    ],
    fields: '{...OpportunityFieldSettingsResponseFields}',
    fragments: [Fragments.opportunityFieldSettingsResponse],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};

export default UPDATE;
